export enum WallChangeEventEnum {
  WallAdded = 1,
  WallDeleted = 2,
  WallRefreshed = 3,
  WallInit = 4
}
